'use client';
import { ComparerType } from '@lib/sanity/queries/modules/comparer/types';
import { TextVariant } from '@ui/Text/constants';
import PortableText from '@ui/Text/PortableText';

type Props = {
  data: ComparerType;
};

const ComparerHeader = ({ data }: Props) => {
  if (!data.title) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2">
      <PortableText content={data.title} variant={TextVariant.TitleMD} className="text-center font-medium" />
    </div>
  );
};

export default ComparerHeader;
